/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth.interceptor';
// import { NativeHttpLayerInterceptor } from './native-http-layer.interceptor';
import { CacheInterceptor } from './cache.interceptor';
import { ConnectionStateInterceptor } from './connection-state.interceptor';
import { HeadersInterceptor } from './headers.interceptor';
/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  // { provide: HTTP_INTERCEPTORS, useClass: NativeHttpLayerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ConnectionStateInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HeadersInterceptor, multi: true },
];
